
import Vue from 'vue';
import _get from 'lodash/get';
import { db } from '@/firebase';
import { RunnitNode } from '@run-diffusion/shared';
import { mapActions, mapState } from 'vuex';
import { SNACKBAR_STATUS } from '@/constants/constants';
import RunnitDialog from '@/views/Runnits/base/RunnitDialog.vue';

export default Vue.extend({
	name: 'RunnitNodeSettingsDialog',
	props: {
		value: { type: Boolean, default: false },
		runnitNode: { type: Object, required: true },
		// If true, saves to database. If false, emits changes to parent
		saveToDatabase: { type: Boolean, default: true },
	},
	data () {
		return {
			open: false,

			// Form
			title: null,
			description: null,

			formValid: false,
			rules: {
				required: [
					v => !!v || 'Required field',
				],
			},

			savingRunnitNodeSettings: false,
		};
	},
	created () {
		this.open = !!this.value;
		// Initialize form with runnitNode data if available
		if (this.runnitNode && this.runnitNode.title) {
			this.title = this.runnitNode.title || '';
			this.description = this.runnitNode.description || '';
		}
	},
	watch: {
		value (newVal: boolean) {
			this.open = !!newVal;
		},
		runnitNode: {
			immediate: true,
			async handler (newVal: RunnitNode, oldVal: RunnitNode) {
				if (newVal && newVal.title) {
					this.title = newVal.title || '';
					this.description = newVal.description || '';
				}
			},
		},
	},
	computed: {
		...mapState([
			'limitNumRunnitsMap',
			'runnitState',
		]),
	},
	methods: {
		...mapActions([
			'updateSnackbar',
		]),
		setOpen (val: boolean) {
			this.open = !!val;
			if (this.open !== this.value) {
				this.$emit('input', this.open);
			}
		},
		onCancel () {
			this.open = false;
			this.$emit('input', this.open);
		},
		async onSaveRunnitNodeSettings () {
			try {
				this.savingRunnitNodeSettings = true;

				if (this.saveToDatabase) {
					// Save to database (original behavior)
					const runnitNodeRef = db.doc(`runnits/${this.runnitNode.runnitId}/runnitNodes/${_get(this.runnitNode, 'id')}`);
					await runnitNodeRef
						.update({
							title: this.title,
							description: this.description,
						});
					this.updateSnackbar({
						status: SNACKBAR_STATUS.SUCCESS,
						message: `Success! ${this.runnitNode.title} Settings saved`,
						show: true,
					});
				} else {
					// Emit changes to parent (template context)
					this.$emit('node-updated', {
						...this.runnitNode,
						title: this.title,
						description: this.description,
					});
					this.updateSnackbar({
						status: SNACKBAR_STATUS.SUCCESS,
						message: `Success! ${this.title} Settings updated`,
						show: true,
					});
				}
			} catch (e) {
				console.error(e);
				this.updateSnackbar({
					status: SNACKBAR_STATUS.ERROR,
					message: 'Error! Problem saving the Tool Settings, please reach out to report issues by going to Resources -> Help from the menu options',
					show: true,
				});
			} finally {
				this.savingRunnitNodeSettings = false;
				this.onCancel();
			}
		},
	},
	components: {
		RunnitDialog,
	},
});
